import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { teamMembers } from "../../data/team";
import { backgroundImg } from "src/assets/assetsExport";

export default function TeamPage(): JSX.Element {
  return (
    <>
      <Helmet>
        <title>Our Team | Letting Engine</title>
        <meta
          name="description"
          content="Meet the Letting Engine team — London property experts dedicated to exceptional letting and landlord services."
        />
      </Helmet>

      <section className="min-h-[60vh] pt-40 pb-16 w-full relative flex items-center justify-center">
        <img
          src={backgroundImg.meeting2}
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-15 filter grayscale contrast-125 pointer-events-none"
          style={{ zIndex: 0 }}
        />
        <div className="relative z-10 text-center max-w-4xl px-6">
          <h1 className="font-teko leading-none mb-6 tracking-[-2px] text-6xl">
            <span className="stroke-1 text-text-slate">Our Team</span>
          </h1>
          <p className="font-manrope text-base leading-relaxed text-text-slate max-w-2xl mx-auto">
            Specialists across Prime Central London, each dedicated to delivering
            a seamless letting experience for landlords and tenants.
          </p>
        </div>
      </section>

      <section className="py-24 px-[5%] bg-bg-porcelain">
        <div className="max-w-[1440px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {teamMembers.map((member) => (
              <article
                key={member.id}
                className="bg-bg-white border border-solid border-[rgba(0,0,0,0.05)] p-8 flex flex-col transition-all duration-300 hover:shadow-soft hover:-translate-y-1"
              >
                <div
                  className="w-20 h-20 rounded-full bg-text-obsidian text-white font-teko text-2xl flex items-center justify-center mb-6"
                  aria-hidden="true"
                >
                  {member.initials}
                </div>
                <h2 className="font-teko text-3xl text-text-obsidian mb-1">
                  {member.name}
                </h2>
                <p className="font-manrope text-sm text-brand-gold uppercase tracking-wider mb-4">
                  {member.role}
                </p>
                <div className="mb-3">
                  <span className="font-manrope text-xs uppercase tracking-wider text-text-slate block mb-1">
                    Areas
                  </span>
                  <p className="font-manrope text-sm text-text-obsidian">
                    {member.areas.join(" · ")}
                  </p>
                </div>
                <div className="mb-4">
                  <span className="font-manrope text-xs uppercase tracking-wider text-text-slate block mb-1">
                    Languages
                  </span>
                  <p className="font-manrope text-sm text-text-obsidian">
                    {member.languages.join(", ")}
                  </p>
                </div>
                <a
                  href={`mailto:${member.email}`}
                  className="font-manrope text-sm text-text-slate hover:text-brand-yellow transition-colors mt-auto"
                >
                  {member.email}
                </a>
              </article>
            ))}
          </div>

          <div className="mt-16 text-center">
            <Link
              to="/about-us"
              className="font-teko text-lg uppercase text-text-obsidian border-b border-b-solid border-b-brand-yellow hover:text-brand-gold transition-colors"
            >
              Back to About Us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
